import {__Type, TObject} from 'ca-middleware';
@__Type({name: 'SymbolConfig', namespace: 'http://www.gsafety.com'})
export default class SymbolConfig extends TObject {
    private icons: object;
    private symbols: object;

    get Icons() {
        return this.icons;
    }

    set Icons(value: object) {
        this.icons = value;
    }

    get Symbols() {
        return this.symbols;
    }

    set Symbols(value: object) {
        this.symbols = value;
    }
}
